import { graphql } from 'babel-plugin-relay/macro'
import { readInlineData } from 'relay-runtime'

import type { productSkuOfferConnection_ProductSkuOfferConnection$key } from './__generated__/productSkuOfferConnection_ProductSkuOfferConnection.graphql'

export const mapOffersToProductPrice = (
  productSkuOfferConnectionRef: productSkuOfferConnection_ProductSkuOfferConnection$key
) => {
  const productSkuOfferConnection = readInlineData(
    graphql`
      fragment productSkuOfferConnection_ProductSkuOfferConnection on ProductSkuOfferConnection
      @inline {
        edges {
          node {
            seller {
              _id
            }
            deliveryChannel
            listPrice {
              amount
            }
            netPrice {
              amount
            }
            priority
          }
        }
      }
    `,
    productSkuOfferConnectionRef
  )

  return productSkuOfferConnection.edges.map((offerEdge) => ({
    deliveryChannel: offerEdge.node.deliveryChannel,
    sellerId: offerEdge.node.seller._id,
    priority: offerEdge.node.priority,
    netPrice: {
      amount: offerEdge.node.netPrice.amount,
    },
    listPrice: {
      amount: offerEdge.node.listPrice.amount,
    },
  }))
}
